import React, { useMemo } from 'react';
import { remainingDistance, remainingMinutes, arrivalTime } from '../lib/route';
import { nextInstruction, formatDistance } from '../lib/instructions';

/**
 * Körvyn: vad du ska göra härnäst, och hur långt det är kvar.
 *
 * Allt annat är borta med flit — det här läser man i en bil, med en blick.
 * Siffrorna räknas om vid varje GPS-uppdatering, så de sjunker medan man
 * kör i stället för att stå kvar på uppskattningen från start.
 */
const ARRIVED_METRES = 60;

const km = (metres) => (
  metres < 1000
    ? `${Math.round(metres / 10) * 10} m`
    : `${(metres / 1000).toFixed(1).replace('.', ',')} km`
);

export default function NavigationHud({ route, info, position, onStop }) {
  const total = info && info.plan ? info.plan.total : 0;

  const metresLeft = useMemo(() => (
    position && route ? remainingDistance(route, position) : total
  ), [route, position, total]);

  if (!route || !info) return null;

  const arrived = metresLeft < ARRIVED_METRES;
  const minutes = remainingMinutes({
    metersLeft: metresLeft,
    totalMeters: total,
    speedKmh: info.speedKmh,
    delaySeconds: info.delaySeconds,
  });

  const instruction = arrived ? null : nextInstruction(info.plan, position);
  const progress = total > 0 ? Math.min(100, Math.max(0, ((total - metresLeft) / total) * 100)) : 0;

  return (
    <>
      <div className="nav-top">
        {arrived ? (
          <p className="nav-top__arrived">Du är framme!</p>
        ) : (
          <>
            <div className="nav-top__figures">
              <span><strong>{km(metresLeft)}</strong></span>
              <span><strong>{minutes} min</strong></span>
              <span className="nav-top__eta">
                <small>FRAMME</small>
                <strong>{arrivalTime(minutes)}</strong>
              </span>
            </div>

            {instruction && (
              <p className="nav-top__instruction">
                {instruction.text}
                <span> {formatDistance(instruction.distance)}</span>
              </p>
            )}
          </>
        )}
      </div>

      <div className="nav-bottom">
        <div className="nav-bottom__progress" aria-hidden="true">
          <span style={{ width: `${progress}%` }} />
        </div>

        <p className="nav-bottom__status">
          {arrived
            ? 'Framme vid målet'
            : `${km(metresLeft)} kvar · ${minutes} min · Beräknad ankomst ${arrivalTime(minutes)}`}
        </p>

        <button className="btn btn--block btn--lg btn--quiet" onClick={onStop}>
          Avsluta navigation
        </button>
      </div>
    </>
  );
}
